<template>
  <section class="section">
    <div class="section__content">
      <HeadingBlock :content="content" />
      <ul class="activity-type__list">
        <ActivityType
          :content="type"
          v-for="(type, typeKey) in content.types"
          :key="typeKey"
          v-reveal="{ delay: 25 * typeKey + 250 }"
        />
      </ul>
    </div>
  </section>
</template>

<script>
import { HeadingBlock } from '@/components/blocks'
import { ActivityType } from '@/components/cards'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'ActivityTypesSection',
  mixins: [DefaultSectionProps],
  components: { ActivityType, HeadingBlock },
}
</script>
